
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 180 180","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M160 48c0-5.795-4.705-10.5-10.5-10.5h-119C24.705 37.5 20 42.205 20 48v84c0 5.795 4.705 10.5 10.5 10.5h119c5.795 0 10.5-4.705 10.5-10.5V48z","fill":"none","stroke":"#323232","stroke-width":"5.83","stroke-dasharray":"29.17,29.17,443.33,0","stroke-dashoffset":"361.67"}}),_c('circle',{attrs:{"cx":"121.955","cy":"68.026","r":"12.49","fill":"none","stroke":"#323232","stroke-width":"5.83"}}),_c('path',{attrs:{"d":"M32.994 121.379L64.373 90l34.492 34.492 21.632-21.632 27.726 27.726","fill":"none","stroke":"url(#LinearGradient)","stroke-width":"5.83"}}),_c('path',{attrs:{"d":"M20 87.193a2.847 2.847 0 01-2.846-2.847v-8.539a2.847 2.847 0 015.692 0v8.539A2.847 2.847 0 0120 87.193","fill":"url(#LinearGradient)","fill-rule":"nonzero"}})])
          )
        }
      }
    